// Generates static `useLocation` hook. The hook always
// responds with initial path provided.
// You can use this for server-side rendering.
export default (function () {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$record = _ref.record,
    record = _ref$record === void 0 ? false : _ref$record;
  var hook;
  var navigate = function navigate(to) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      replace = _ref2.replace;
    if (record) {
      if (replace) {
        hook.history.pop();
      }
      hook.history.push(to);
    }
  };
  hook = function hook() {
    return [path, navigate];
  };
  hook.history = [path];
  return hook;
});